import { useEffect, useRef } from 'react';

const PdfViewerComponent = ({ fileUrl }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (fileUrl) {
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          iframeRef.current.src = url;
          // Clean up on unmount
          return () => URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Error fetching PDF:', error));
    }
  }, [fileUrl]);

  return (
    <div className="flex flex-col lg:flex-row border-b border-gray-200 pb-5 -mx-5">
      {fileUrl ? (
        <iframe
          ref={iframeRef}
          width="100%"
          height="1100"
          title="Quotation PDF"
          className="w-full"
        />
      ) : (
        <div className="w-full text-center text-gray-500 py-10">
          No document available.
        </div>
      )}
    </div>
  );
};

export default PdfViewerComponent;